module.exports = __webpack_public_path__ + "static/media/1.b4da47d3.jpg";